import lightPalette from './lightPalette';

const themePalette = (color:any, mode:any) => {
    return lightPalette[color];
};

export default themePalette;
